(function(){
  'use strict';

  function initSection(root){
    if (root.dataset.pqInit) return;
    root.dataset.pqInit = '1';

    /* ---- reveal on scroll ---- */
    var revealEls = root.querySelectorAll('[data-pq-reveal]');
    if ('IntersectionObserver' in window && revealEls.length){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if (entry.isIntersecting){
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
      revealEls.forEach(function(el){ io.observe(el); });
    } else {
      revealEls.forEach(function(el){ el.classList.add('is-visible'); });
    }

    /* ---- parallax hero ---- */
    var heroBg = root.querySelector('[data-pq-parallax]');
    var stickybar = root.querySelector('[data-pq-stickybar]');
    var onScroll = function(){
      if (heroBg){
        var strength = parseFloat(heroBg.dataset.pqParallax) || 0.22;
        var rect = root.getBoundingClientRect();
        heroBg.style.transform = 'translate3d(0,' + (Math.max(0, -rect.top) * strength).toFixed(1) + 'px,0)';
      }
      if (stickybar){
        var y = window.scrollY || window.pageYOffset || 0;
        stickybar.classList.toggle('is-visible', y > 620);
      }
    };
    var raf = null;
    window.addEventListener('scroll', function(){
      if (raf) return;
      raf = requestAnimationFrame(function(){ raf = null; onScroll(); });
    }, { passive: true });
    onScroll();

    /* ---- stock countdown ---- */
    var stockEl = root.querySelector('[data-pq-stock]');
    var stockBar = root.querySelector('[data-pq-stock-bar]');
    if (stockEl){
      var stock = Math.max(1, parseInt(stockEl.dataset.pqStock, 10) || 17);
      var floor = Math.max(1, Math.round(stock * 0.35));
      var render = function(){
        stockEl.textContent = stock;
        if (stockBar) stockBar.style.width = Math.min(100, Math.round(stock / 50 * 100)) + '%';
      };
      render();
      var stockIv = setInterval(function(){
        if (stock <= floor){ clearInterval(stockIv); return; }
        stock -= 1;
        render();
        stockEl.style.animation = 'pqPop .5s ease';
        setTimeout(function(){ stockEl.style.animation = ''; }, 520);
      }, 11000);
    }

    /* ---- before / after slider ---- */
    var ba = root.querySelector('[data-pq-ba]');
    if (ba){
      var clip = ba.querySelector('[data-pq-ba-clip]');
      var handle = ba.querySelector('[data-pq-ba-handle]');
      var dragging = false;
      var move = function(clientX){
        var box = ba.getBoundingClientRect();
        var p = Math.max(3, Math.min(97, (clientX - box.left) / box.width * 100));
        if (clip) clip.style.width = p + '%';
        if (handle) handle.style.left = p + '%';
      };
      ba.addEventListener('pointerdown', function(e){
        dragging = true;
        if (ba.setPointerCapture) ba.setPointerCapture(e.pointerId);
        move(e.clientX);
      });
      ba.addEventListener('pointermove', function(e){ if (dragging) move(e.clientX); });
      ba.addEventListener('pointerup', function(){ dragging = false; });
      ba.addEventListener('pointercancel', function(){ dragging = false; });
    }

    /* ---- level picker (visual / informational only) ---- */
    var levelButtons = root.querySelectorAll('[data-pq-level]');
    var levelNote = root.querySelector('[data-pq-level-note]');
    var levelTip = root.querySelector('[data-pq-level-tip]');
    var levelGlow = root.querySelector('[data-pq-level-glow]');
    var levelColors = { '1': '#f0d264', '2': '#e8a94a', '3': '#e0a03c', '4': 'var(--pq-accent)' };
    function pickLevel(lv){
      levelButtons.forEach(function(b){ b.setAttribute('aria-pressed', b.dataset.pqLevel === lv ? 'true' : 'false'); });
      var col = levelColors[lv] || levelColors['3'];
      if (levelTip) levelTip.style.background = col;
      if (levelGlow) levelGlow.style.background = 'radial-gradient(circle,' + col + '99,' + col + '00 68%)';
      if (levelNote){
        var text = levelNote.getAttribute('data-pq-text-' + lv);
        if (text){
          levelNote.style.opacity = '0';
          setTimeout(function(){ levelNote.textContent = text; levelNote.style.opacity = '1'; }, 140);
        }
      }
    }
    levelButtons.forEach(function(b){
      b.addEventListener('click', function(){ pickLevel(b.dataset.pqLevel); });
    });

    /* ---- FAQ accordion ---- */
    root.querySelectorAll('[data-pq-faq]').forEach(function(item){
      var q = item.querySelector('[data-pq-faq-q]');
      var a = item.querySelector('[data-pq-faq-a]');
      if (!q || !a) return;
      q.addEventListener('click', function(){
        var open = item.getAttribute('aria-expanded') === 'true';
        root.querySelectorAll('[data-pq-faq]').forEach(function(other){
          other.setAttribute('aria-expanded', 'false');
          other.querySelector('[data-pq-faq-a]').style.maxHeight = '0px';
        });
        if (!open){
          item.setAttribute('aria-expanded', 'true');
          a.style.maxHeight = a.scrollHeight + 'px';
        }
      });
    });

    /* ---- bundle / variant picker wired to the real Shopify cart form ---- */
    var bundleButtons = root.querySelectorAll('[data-pq-bundle]');
    var form = root.querySelector('.product-form');
    var variantInput = form ? form.querySelector('.product-variant-id, [name="id"]') : null;
    var stickyPrice = root.querySelector('[data-pq-sticky-price]');
    var stickySub = root.querySelector('[data-pq-sticky-sub]');
    var heroPrice = root.querySelector('[data-pq-hero-price]');
    var heroWas = root.querySelector('[data-pq-hero-was]');
    var heroDisc = root.querySelector('[data-pq-hero-disc]');
    var submitLabel = form ? form.querySelector('.product-form__submit span:first-child') : null;
    var addToCartBase = 'Ajouter au panier';

    function selectBundle(btn){
      bundleButtons.forEach(function(b){ b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      if (!btn) return;
      var variantId = btn.dataset.pqVariantId;
      if (variantInput && variantId){ variantInput.value = variantId; variantInput.disabled = false; }
      var price = btn.dataset.pqPrice;
      var title = btn.dataset.pqTitle;
      var note = btn.dataset.pqNote;
      if (stickyPrice && price) stickyPrice.textContent = price;
      if (stickySub) stickySub.textContent = [title, note].filter(Boolean).join(' · ');
      if (submitLabel && price) submitLabel.textContent = addToCartBase + ' · ' + price;
    }
    bundleButtons.forEach(function(btn){
      btn.addEventListener('click', function(){ selectBundle(btn); });
    });
    var preselected = root.querySelector('[data-pq-bundle][data-pq-default="true"]') || bundleButtons[0];
    if (preselected) selectBundle(preselected);

    /* keep hero display in sync with the first (cheapest) pack, informational only */
    if (heroPrice && bundleButtons.length){
      var first = bundleButtons[0];
      if (first.dataset.pqUnitPrice) heroPrice.textContent = first.dataset.pqUnitPrice;
      if (heroWas && first.dataset.pqUnitWas) heroWas.textContent = first.dataset.pqUnitWas;
      if (heroDisc && first.dataset.pqUnitDisc) heroDisc.textContent = first.dataset.pqUnitDisc;
    }

    /* ---- scroll-to-bundles CTAs ---- */
    root.querySelectorAll('[data-pq-scroll-to-bundles]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var target = root.querySelector('[data-pq-bundles-anchor]');
        if (!target) return;
        var top = target.getBoundingClientRect().top + window.scrollY - 90;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
  }

  function boot(){
    document.querySelectorAll('[data-pq-root]').forEach(initSection);
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function(e){
    var root = e.target.querySelector ? e.target.querySelector('[data-pq-root]') : null;
    if (root) initSection(root);
  });
})();
